var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWear1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5736 50.2401C36.1936 49.9001 36.0136 51.8701 35.5036 52.7401L34.8736 52.7201C33.2436 51.5001 26.5536 48.0001 27.0236 46.0701C27.3336 44.8001 34.6536 35.8701 36.0436 34.8101C42.5736 29.8401 43.8236 34.0001 47.4436 39.1301C48.6736 39.1301 50.3336 35.6601 53.4136 37.5801C54.0336 37.9601 54.0036 39.3201 55.0236 39.1201C55.9136 38.9401 58.8536 33.4101 59.8436 32.8001C61.2936 31.9101 65.2336 33.7301 66.5836 34.6601C68.0736 35.6901 74.4136 43.7401 75.4536 45.5301C75.6836 45.9301 76.1036 46.4601 75.9936 46.9201L68.0936 52.7201L65.9136 50.5001L64.9636 51.0801L64.9136 73.7901C63.5336 74.8201 43.3736 74.8001 40.3436 74.5601C39.3736 74.4801 38.5136 74.2601 37.5836 74.0301V50.2601L37.5736 50.2401Z",
    fill: "#0256B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6636 33.1C51.2536 35.23 49.1436 36.22 47.9436 37.58C41.6936 31.08 41.2336 27.22 50.6636 33.1Z",
    fill: "#0256B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6935 36.99C54.0635 38.18 51.1735 33.91 51.7535 33.07L58.5535 30.01C61.1335 30.52 55.9635 35.93 55.6935 36.99Z",
    fill: "#0256B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2936 29C54.5163 30.9723 53.0644 31.9025 51.4441 31.8511C49.8162 31.7994 47.1321 30.7512 46.6836 29H56.2936Z",
    fill: "#0256B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWear1);
export default __webpack_public_path__ + "static/media/wear1.6dc1ebef2d482aff6e6ed2f997e31acb.svg";
export { ForwardRef as ReactComponent };